import actArticle from "./articles";
import actAuth from "./auth";
import actGraph from "./graph";

export default {
  ...actGraph,
  ...actAuth,
  ...actArticle,
};
